import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { map, switchMap, catchError } from 'rxjs/operators';
import {
  CREATE_CAMPAIGN,
  CREATE_CAMPAIGN_SUCCESS
} from '../../constants';

const fetchCampaigns = (action$, state$) =>
  action$.pipe(
    ofType(CREATE_CAMPAIGN),
    switchMap(action => {
      console.log(action.payload)
      return ajax({
        url:  `${state$.value.auth.server}/campaign`,
        headers: {
          Authorization: state$.value.auth.token,
          'Content-Type': `multipart/form-data; boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW`
        },
        responseType: 'json',
        crossDomain: true,
        body: JSON.stringify(action.payload),
        method: 'POST',
      }).pipe(
        map(response => {
          console.log(response.response);
          return {
            type: CREATE_CAMPAIGN_SUCCESS,
            data: response.response
          };
        }),
        catchError(error => {
          console.log(error);
        })
      );
    })
  );

export default fetchCampaigns;
